import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { NotificationsType } from 'domain/models/notification'
import { PaginationEmpty } from 'domain/models/queryPagination'
import { ReadNotificationsQueryResponse } from 'domain/entities/notifications'
import { RootState } from 'presentation/redux/reducers'

export const initialState: NotificationsType = {
  error: null,
  isLoading: false,
  notifications: [],
  pagination: PaginationEmpty,
}

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    getNotificationsStart: (state: NotificationsType) => {
      state.isLoading = true
      state.error = null
    },
    getNotificationsSuccess: (
      state: NotificationsType,
      action: PayloadAction<ReadNotificationsQueryResponse>,
    ) => {
      state.isLoading = false
      state.notifications = action.payload.entities
      state.pagination = action.payload.pagination
    },
    getNotificationsError: (state: NotificationsType, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    createNotificationAsReadStart: (state: NotificationsType) => {
      state.isLoading = true
      state.error = null
    },
    createNotificationAsReadSuccess: (state: NotificationsType) => {
      state.isLoading = false
    },
    createNotificationAsReadError: (state: NotificationsType, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export const notificationsState = (state: RootState) => state.notifications
export const {
  getNotificationsStart,
  getNotificationsSuccess,
  getNotificationsError,
  createNotificationAsReadStart,
  createNotificationAsReadSuccess,
  createNotificationAsReadError,
} = notificationsSlice.actions

export default notificationsSlice.reducer
